import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AuthService } from '../../../../system/auth.service';
import { QuestionsService } from '../../../../api/Services/maintenance/questions.service';
import { ToastrService } from 'ngx-toastr';
import { TabService } from '../../../../tabconfig/tab.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DialogService } from '../../../../common/dialog.service';
import { ModuleService } from '../../../../api/Services/maintenance/module.service';
import { OptionsComponent } from '../../options/options.component';
import { CoursesQuizCreateQuestionComponent } from '../../courses/courses-quiz-create-question/courses-quiz-create-question.component';
import { CourseQuizService } from '../../../../api/Services/maintenance/course-quiz.service';
import { CoursesQuizCreateBodyComponent } from '../../courses/courses-quiz-create-body/courses-quiz-create-body.component';
import { CoursesQuizCreateHeaderComponent } from '../../courses/courses-quiz-create-header/courses-quiz-create-header.component';

@Component({
  selector: 'app-questions-add',
  templateUrl: './questions-add.component.html',
  styleUrls: ['./questions-add.component.css']
})
export class QuestionsAddComponent implements OnInit {

  @BlockUI() blockUI: NgBlockUI;
  message_loading: string;
  public parameters: any[];
  
  public editActivo = false;
  public displayedColumns: string[] = ['que_tx_description', 'opcion'];
  public dataSource = new MatTableDataSource<any[]>();
  
  @Input() cou_in_id;
  @Input() moduleList: any;
  @Input() default_select_module: number;
  
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('paginatorDatasource', { read: MatPaginator, static: true }) paginator: MatPaginator;

  ContentQuestionsCourses: FormGroup;
  public default_select_module_empty:string;

  coquti_tx_description:string='';
  coquti_bi_id:number=0;
  bPermission:Boolean = true;
  dataQuiz:any[];

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private questionServices: QuestionsService,
    private moduleServices: ModuleService,
    private courseQuizServices: CourseQuizService,
    private toastr: ToastrService,
    private tabService: TabService,
    private dialog: MatDialog,
    private dialogService: DialogService
  ) { 
    this.message_loading = "Cargando...";
  }

  ngOnInit(): void {
    this.initForm();
    this.LoadInitial();
    this.default_select_module_empty = '';
  }

  public initForm() {
     
    this.ContentQuestionsCourses = this.formBuilder.group({
      que_bi_id: [null],
      mod_in_id: [null, Validators.required],
      que_tx_description: [null, Validators.required],
      que_in_order: [null],
      que_in_status: [1]
    });
  }
  public LoadInitial() {
    this.parameters = this.authService.getParameters();
  }
  public onChangeModuleQuestion(value) {
    if (value != null) {

      if(value!=''){
        console.log('onChangeModuleMovie=>' + value);
        var cou_in_id = this.cou_in_id;
        this.default_select_module = value;
        this.coquti_bi_id = value;
        this.loadQuestion();
      }
      else{
        this.dataSource = null;
        this.coquti_bi_id = 0;
        this.dataQuiz = null;
      }
     

    }




  }

 
  public cancel(){
    this.editActivo = false;
    this.ContentQuestionsCourses.reset();
    this.default_select_module_empty = '';
    this.dataSource = null;
  }
 

 
 
  addquestion()
  {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = false;
      dialogConfig.autoFocus = true;
      dialogConfig.data = this.coquti_bi_id;
      dialogConfig.minWidth = '50%';
      const dialogRef = this.dialog.open(CoursesQuizCreateQuestionComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
         this.loadQuestion();
      });
      
      
  
     
  }


  loadQuestion(){
    this.courseQuizServices.GetAlltQuiz(this.coquti_bi_id).subscribe(
      data => {
        console.log(data);

        if (data['sucess']) {
          console.log(data['data']);
          this.dataQuiz = data['data'];
        }
        else {
          this.toastr.warning(data['msg'], 'Advertencia');
        }
      }
    );
  }

  deletequestion(element){

    this.dialogService.openConfirmDialog('¿Seguro de eliminar esta pregunta?')
    .afterClosed().subscribe(res => {
      this.courseQuizServices.DeleteQuiz(element.coqu_bi_id).subscribe(
        data => {
          if (data['sucess']) {
            this.loadQuestion();
            this.toastr.success(data['msg'], 'Correcto');
          }
          else {
            this.toastr.warning(data['msg'], 'Advertencia');
          }
        }
      );

    });

  }
  
  addHeader(element){
    const dialogConfig = new MatDialogConfig();
       
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.data = element;
    dialogConfig.minWidth = '50%';
   

    const dialogRef = this.dialog.open(CoursesQuizCreateHeaderComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
       this.loadQuestion();
    });
  }
  addBody(element){
    const dialogConfig = new MatDialogConfig();
       
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.data = element;
    dialogConfig.minWidth = '50%';
   

    const dialogRef = this.dialog.open(CoursesQuizCreateBodyComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
       this.loadQuestion();
    });
  }

  deleteBody(element){

    this.dialogService.openConfirmDialog('¿Seguro de eliminar esta fila?')
    .afterClosed().subscribe(res => {
      this.courseQuizServices.DeleteQuizBody(element.coqubo_bi_id).subscribe(
        data => {
         
          if (data['sucess']) {
            this.loadQuestion();
            this.toastr.success(data['msg'], 'Correcto');
          }
          else {
            this.toastr.warning(data['msg'], 'Advertencia');
          }
        }
      );

    });

  }
  deleteHeader(element){

    this.dialogService.openConfirmDialog('¿Seguro de eliminar esta columna?')
    .afterClosed().subscribe(res => {
      this.courseQuizServices.DeleteQuizHeader(element.coquhe_bi_id).subscribe(
        data => {
         
          if (data['sucess']) {
            
            this.loadQuestion();
            this.toastr.success(data['msg'], 'Correcto');
          }
          else {
            this.toastr.warning(data['msg'], 'Advertencia');
          }
        }
      );

    });

  }
}
